"use client";

import { motion } from "framer-motion";
import videoPoster from "@/assets/video-poster.jpg";
import { Play } from "lucide-react";

export function VideoSection() {
  return (
    <section className="py-28 lg:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div 
          className="text-center max-w-2xl mx-auto mb-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-xs uppercase tracking-[0.25em] text-primary mb-5">The Film</p>
          <h2 className="text-4xl lg:text-5xl font-semibold tracking-tight">
            See Apollo in motion.
          </h2>
        </motion.div>
        
        <motion.div 
          className="relative overflow-hidden rounded-3xl group cursor-pointer"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
        >
          <img
            src={videoPoster.src}
            alt="Apollo G3 cinematic film"
            width={1920}
            height={1080}
            loading="lazy"
            className="w-full aspect-video object-cover transition-transform duration-700 group-hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          <button
            type="button"
            aria-label="Play film"
            className="absolute inset-0 flex items-center justify-center"
          >
            <span className="flex h-20 w-20 lg:h-24 lg:w-24 items-center justify-center rounded-full bg-background/95 backdrop-blur shadow-2xl group-hover:scale-110 transition-transform">
              <Play className="h-7 w-7 text-foreground ml-1" fill="currentColor" />
            </span>
          </button>
          <div className="absolute bottom-8 left-8 text-white">
            <p className="text-xs uppercase tracking-[0.2em] opacity-80">2:14</p>
            <p className="text-lg font-medium mt-1">A day with Apollo</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
